import { useTokenStore } from 'Shared/hooks/useTokenStore';
import { QUERY_KEY } from '@constants';
import type { QueryParam } from 'viewup-lib/common';
import { useSDQuery } from 'viewup-lib/react';
import { type GetViewupPlusSnsAccountsRes, getViewupPlusSnsAccounts } from './mapper';

export const useGetViewupPlusSnsAccounts = (params?: QueryParam<GetViewupPlusSnsAccountsRes>) => {
  const { accessToken } = useTokenStore();

  return useSDQuery<GetViewupPlusSnsAccountsRes>({
    ...params?.options,
    enabled: params?.options?.enabled ?? !!accessToken,
    queryKey: [QUERY_KEY.SNS_ACCOUNTS_VIEWUP_PLUS],
    queryFn: () => getViewupPlusSnsAccounts(),
  });
};
